/**
 * White-label branding — single source of truth for tenant identity.
 * Swap these values (and the logo asset in public/) when Karrierehuset
 * delivers brand assets; nothing else should hardcode names or colors.
 */
const branding = {
  productName: 'Karrierehuset Kompetanseportal',
  companyName: 'Karrierehuset AS',
  poweredBy: 'Qualitati',
  logoPath: '/logo192.png', // replace with Karrierehuset logo asset
  supportEmail: 'contact@qualitati.com',
  palette: {
    // placeholder palette until brand assets arrive (kickoff agenda item)
    primary: '#1C3D5A',   // deep Nordic blue
    secondary: '#E8B44F', // warm accent
  },
  defaultLanguage: 'nb',
};

export default branding;
